import React from "react";
import Box from "@mui/material/Box";
import AssessmentTwoToneIcon from "@mui/icons-material/AssignmentTwoTone";

import { useGetSeachParam } from "../useSearchParams";
import ContextInfo from "./ContextInfo";
import EmptyItem from "../Components/EmptyItem";
import SearchResult from "./SearchResult";
import useTags from "./useTags";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AddButton from "./AddButton";

function LibraryList({ myPractitionerCode, library }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const selectedItem = Number(useGetSeachParam("i"));
  const contextId = Number(useGetSeachParam("c"));
  const isEmpty = library.flatMap((page) => page.list).length === 0;
  const { tags } = useTags();
  const items = library.flatMap((group) => group.list.map((item) => item));
  const renderItems = items?.map((item) => (
    <Box key={`Box${item.id}`} paddingBottom={2}>
      <SearchResult
        item={item}
        tags={tags?.list?.filter((tag) => item.tagIds.includes(tag.id)) ?? []}
        selectedItem={selectedItem}
        isEditable={item.code === myPractitionerCode}
      />
    </Box>
  ));

  return (
    <React.Fragment>
      <Box>
        {pathname === "/library/local" ? (
          <Box padding={2}>
            <AddButton />
          </Box>
        ) : null}
        {contextId ? (
          <Box padding={2} paddingBottom={0}>
            <ContextInfo />
          </Box>
        ) : null}
        {isEmpty ? (
          <Box padding={2}>
            <EmptyItem
              text={t("common.noResults")}
              Icon={AssessmentTwoToneIcon}
            />
          </Box>
        ) : null}
      </Box>
      <Box padding={2}>{renderItems.map((item) => item)}</Box>
    </React.Fragment>
  );
}

export default LibraryList;
